import { DataTypeConfig } from "../../../../types";

export const assetsConfig: DataTypeConfig = {
  tabs: [
    "assetClass",
    "assetType",
    "manufacturer",
    "status",
    "depreciationMethod",
  ],
  searchableColumns: [
    "Asset Name",
    "Facility ID",
    "System/Network ID",
    "Asset Class",
    "Asset Type",
    "Location",
    "Serial Number",
    "Manufacturer",
    "Status",
  ],
  filterColumns: [
    { column: "Asset Class", type: "dropdown", label: "Asset Class" },
    { column: "Asset Type", type: "dropdown", label: "Asset Type" },
    { column: "Manufacturer", type: "dropdown", label: "Manufacturer" },
    { column: "Status", type: "dropdown", label: "Status" },
    {
      column: "Depreciation Method",
      type: "dropdown",
      label: "Depreciation Method",
    },
    {
      column: "Installation Year",
      type: "date",
      label: "Installation Year",
    },
    { column: "Installation Cost", type: "range", label: "Installation Cost" },
    { column: "Replacement Cost", type: "range", label: "Replacement Cost" },
    { column: "Useful Life", type: "range", label: "Useful Life" },
  ],
  tableColumns: [
    { key: "assetName", header: "Asset Name", type: "custom" },
    { key: "facilityId", header: "Facility ID", type: "custom" },
    { key: "systemNetworkId", header: "System/Network ID", type: "custom" },
    { key: "assetClass", header: "Asset Class", type: "badge" },
    { key: "assetType", header: "Asset Type", type: "badge" },
    { key: "location", header: "Location", type: "custom" },
    { key: "serialNumber", header: "Serial Number", type: "custom" },
    { key: "manufacturer", header: "Manufacturer", type: "badge" },
    { key: "status", header: "Status", type: "badge" },
    { key: "depreciationMethod", header: "Depreciation Method", type: "badge" },
    { key: "lat", header: "Latitude", type: "custom" },
    { key: "long", header: "Longitude", type: "custom" },
    { key: "installationYear", header: "Installation Year", type: "custom" },
    { key: "usefulLife", header: "Useful Life", type: "custom" },
    { key: "installationCost", header: "Installation Cost", type: "custom" },
    { key: "replacementCost", header: "Replacement Cost", type: "custom" },
  ],
  mandatoryFields: [
    "Asset Name",
    "Facility ID",
    "System/Network ID",
    "Asset Class",
    "Asset Type",
    "Location",
    "Installation Year",
    "Serial Number",
    "Useful Life",
    "Manufacturer",
    "Status",
    "Installation Cost",
    "Replacement Cost",
    "Depreciation Method",
  ],
};

export const assetsTabDisplayNames: Record<string, string> = {
  assetClass: "Asset Class",
  assetType: "Asset Type",
  manufacturer: "Manufacturer",
  status: "Status",
  depreciationMethod: "Depreciation Method",
};

export const assetsTabDropdownOptions = (tabName: string) => {
  switch (tabName) {
    case "assetClass":
      return [
        { value: "pipe", label: "Pipe" },
        { value: "valve", label: "Valve" },
        { value: "pump", label: "Pump" },
        { value: "tank", label: "Tank" },
        { value: "meter", label: "Meter" },
      ];
    case "assetType":
      return [
        { value: "main_line", label: "Main Line" },
        { value: "service_line", label: "Service Line" },
        { value: "gate_valve", label: "Gate Valve" },
        { value: "check_valve", label: "Check Valve" },
        { value: "centrifugal_pump", label: "Centrifugal Pump" },
      ];
    case "manufacturer":
      return [
        { value: "abb", label: "ABB" },
        { value: "siemens", label: "Siemens" },
        { value: "grundfos", label: "Grundfos" },
        { value: "schneider", label: "Schneider Electric" },
      ];
    case "status":
      return [
        { value: "active", label: "Active" },
        { value: "inactive", label: "Inactive" },
        { value: "under_maintenance", label: "Under Maintenance" },
        { value: "decommissioned", label: "Decommissioned" },
      ];
    case "depreciationMethod":
      return [
        { value: "straight_line", label: "Straight Line" },
        { value: "declining_balance", label: "Declining Balance" },
        { value: "units_of_production", label: "Units of Production" },
      ];
    default:
      return [];
  }
};
